import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type StaticListFilter } from '../types/filters';

export const defaultPostingSource = {
  value: '0',
  label: 'Unified (COSMOS)',
  limit: 1,
};

export const POSTINGS_SOURCE_OPTIONS = [
  defaultPostingSource,
  { value: '2', label: 'Website Postings (other)' },
  { value: '8', label: 'Revelio Labs Website Postings' },
  { value: '3', label: 'LinkedIn' },
  { value: '4', label: 'Indeed' },
];

export const postingsSourceDefinition: FilterDefinition<StaticListFilter> = {
  id: FilterId.POSTINGS_SOURCE,
  name: 'Posting Source',
  selections: [],
  type: FilterType.STATIC_LIST,
  isVisible: true,
};

export const postingsSourceHandler: FilterHandler<StaticListFilter> = {
  isActive() {
    return true;
  },
  isDefault(currentFilterState: StaticListFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(
    currentFilterState: StaticListFilter,
    definition: FilterDefinition<StaticListFilter>
  ) {
    const isUserSubmitted = !this.isDefault(currentFilterState, definition);

    if (currentFilterState.selections.length > 0) {
      return {
        ...currentFilterState,
        isVisible: isUserSubmitted,
        isUserSubmitted,
      };
    }

    return {
      ...definition,
      selections: [
        {
          id: defaultPostingSource.value,
          name: defaultPostingSource.label,
          limit: defaultPostingSource.limit,
        },
      ],
      isVisible: isUserSubmitted,
      isUserSubmitted,
    };
  },
};
